import type React from 'react'

import css from '../../styles.module.scss'
import type { ChartTick } from '../../useDailyUsageChart'

interface ChartYAxisProps {
  ticks: ChartTick[]
}

export const ChartYAxis: React.FC<ChartYAxisProps> = ({ ticks }) => (
  <div className={css.y_axis}>
    {ticks.map((tick) => (
      <span
        key={tick.value}
        className={css.y_label}
        style={{ bottom: `${tick.bottom}%` }}
      >
        {tick.value}
      </span>
    ))}
  </div>
)
